import '../../../../../stylesheets/nav/profile-popover.css'
import { useState, useEffect }      from 'react'
import { useUsage }                 from '../../../../../hooks/external/proprietary/handlers/useUsage.js'
import { getFirstNamePossessive }   from '../../../../../utilities/nameParsing.js'
import { Fragment }                 from 'react'
import LoadingAnimation             from '../../../../loading/LoadingAnimation.js'
import StatsSkeleton                from '../../../../skeletons/StatsSkeleton.js'

const SubscriptionStats = ( { user } ) => {

    //TODO NEXT: spinner annimation in the jsx for the isLoading branch of logic
    //THEN TEST: 
        // 1. delete all usage and make sure we are still not getting that throw error 
        // a. (i.e. we are synthetically re-creating a first sign up edge case with no usage)
        // b. because the usage API request should now only run after the user crosses over to paid, and therefore the only time the usage stats mounts
        // c. meaning by the time they are routed back to app after successful check out these is always at least 1 API use in db
        // 2. live up to date usage
        // a. again since now this is lazy fetch, its only requested on mount and therefore reading the layest from teh db
        // b. instead of stuck at state of when dashboard node boundary loads and not re-reading from db until user basically navigates away and comes back for a new session

    // -- HOOKS -- //
    const { handleUsageStatsComps }                         = useUsage()
    // -- STATEFUL VARS -- //
    const [compsUsageStats, setCompsUsageStats]             = useState(null)
    const [isLoading, setIsLoading]                         = useState(true)

    useEffect(() => {
        const fetchCompsUsageStats = async () => {
            try {
                // this is a hook because its calling a hook (-> handle layer -> call Layer -> baseAPIinstance which uses getAccessTokenSilently to append to authorization header, making it a hook, meaning everything that calls it in the chain has to become a hook)
                const compsUsageStats = await handleUsageStatsComps()
                console.log("[Comps Usage Stats]:", compsUsageStats)

                setCompsUsageStats(compsUsageStats)
                setIsLoading(false)

            } catch (error) {
                console.error('✗ [ERROR] loading comps usage stats:', error.response?.data?.message)
                // logs undefined on network errors — no response = no response prop on the error object = no status code because status codes are only on the response prop on the error object
                console.error('✗ [STATUS]:', error.response?.status)
            }
        }
        fetchCompsUsageStats()
    }, [])   

    // Gate Pattern = encapsulated at component level rather than LCA; because 'Sole Consumer' of this resource, for right now
    if ( isLoading ) {
        return (
            <StatsSkeleton />
        )
    }        

    // return an array of all the counts and then pass that into the max()method on Math class to return the max value
    const maxValue  = Math.max(...compsUsageStats.map(element => element.count))
    const calcWidth = (element) => (element.count / maxValue) * 100

    return (
        <div className="subscription-stats-content-container">
            {/* Main Col 1 of 3: Outer - Left Margin PlaceHolder */} 
            <div className="main-column-one"></div>
            {/* Main Col 2 of 3: Outer + 3 Column Grid Inner */}                        
            <div className="main-column-two stats">
                {/* Direct Children Inside Grid = Each as a Grid Cell w/ Direction Controlled by grid parent css style prop 'grid-auto-flow: [row/column]'; */}
                {/* Grid Cell 1-3: outside map for grid label - has style prop to spans all three columns (i.e. entire first row)*/}
                <div className="subscription-stats-grid-label"> {getFirstNamePossessive(user)} Top Benchmarked Sectors</div>
                {/* Rest of Grid Cells Dynamically Printed- Symetrical Content Print Across Rows First - Hydrated with Retrieved Resource */}
                { compsUsageStats.map((element, i) => (
                    <Fragment key={i}>
                        <div   className="subscription-stats-label"                                            > { element.categoryName } </div>
                        <div   className="subscription-stats-pill"  style={{ width: `${calcWidth(element)}%` }}>                          </div>
                        <span  className="subscription-stats-value"                                            > { element.count }        </span>
                    </Fragment>
                )) }
            </div>
           {/* Main Col 3 of 3: Outer - Right Margin PlaceHolder */}
           <div className="main-column-three"></div>
        </div>
    )

}

export default SubscriptionStats
